import {
    useCallback,
} from 'react'
import useSimpleApiRequest from 'app/hooks/useSimpleApiRequest'

import useFilter from 'app/hooks/useFilter'
import {
    AsyncMutationOptions,
} from 'app/types/request.types'

import requests from 'app/requests/Prebooking.requests'
import PreBookingSpreadsheet from '../PreBookingSpreadsheet'
import {
    convertToPrebookingEntity,
} from '../PreBookingSpreadsheet/PrebookingSpreadsheet.utils'
import {
    PreBookingEntitySpreadsheetData,
} from '../PreBookingSpreadsheet/PreBookingSpreadsheet.config'

const PreBookingBulkCreate = ({
    onClose,
}: Readonly<{ onClose: () => void }>) => {
    const filterOptions = useFilter()

    const {
        mutateAsync: bulkCreate,
    } = useSimpleApiRequest({
        name: 'PreBookingsBulkCreate',
        requestParams: requests.bulkCreate(),
        title: 'New pre-bookings were created',
        onSuccess: () => {
            filterOptions.setDefaultData()
        },
    })

    const onSave = useCallback(async (
        preBookings: PreBookingEntitySpreadsheetData[], options?: AsyncMutationOptions,
    ) => {
        await bulkCreate(convertToPrebookingEntity(preBookings), {
            ...options,
            onSuccess: options?.onSuccess || onClose,
        })
    }, [
        onClose,
        bulkCreate,
    ])

    return (
        <PreBookingSpreadsheet
            filterOptions={filterOptions}
            onSave={onSave}
            onCancel={onClose}
            enableAddNewRows
        />
    )
}

export default PreBookingBulkCreate
